import { scaleLinear } from 'd3-scale';

import { TICK_WIDTH } from './constant';

const RIGHT_Y_AXIS_MIN_MAX = 7;

const getLeftYAxisTicks = (maxValue: number): number[] => {
  if (maxValue <= 0) {
    return [0, 25, 50, 75, 100];
  }

  if (maxValue < 103) {
    const step = Math.ceil(maxValue / 4);
    return [0, step, step * 2, step * 3, step * 4];
  }

  const step = Math.ceil((maxValue - 100) / 3);
  return [0, 100, 100 + step, 100 + step * 2, 100 + step * 3];
};

const getRightYAxisTicks = (maxRate: number): number[] => {
  const max = Math.max(RIGHT_Y_AXIS_MIN_MAX, Math.ceil(maxRate));
  return [0, 1, 3, 5, max];
};

const createEvenScale = (ticks: number[], innerHeight: number) => {
  const segmentHeight = innerHeight / (ticks.length - 1);
  const range = ticks.map((_, i) => innerHeight - i * segmentHeight);

  return scaleLinear().domain(ticks).range(range).clamp(true);
};

const topRoundedRectPath = (x: number, y: number, yStart: number) => {
  const radius = TICK_WIDTH / 2;

  return `
    M ${x},${yStart}
    L ${x},${y + radius}
    A ${radius},${radius} 0,0,1
      ${x + TICK_WIDTH},${y + radius}
    L ${x + TICK_WIDTH},${yStart}
    Z
  `;
};

const rectPath = (x: number, y: number, yStart: number) => {
  return `
    M ${x},${yStart}
    L ${x},${y}
    L ${x + TICK_WIDTH},${y}
    L ${x + TICK_WIDTH},${yStart}
    Z
  `;
};

export { getLeftYAxisTicks, getRightYAxisTicks, createEvenScale, topRoundedRectPath, rectPath };
